/* Where the legal texts live (on the public site). */
const BASE='https://plumeplaner.de';
export const LEGAL={terms:BASE+'/agb',privacy:BASE+'/datenschutz',imprint:BASE+'/impressum',dpa:BASE+'/avv',dpaPdf:BASE+'/avv.pdf'};
export const ext=(href,label)=>`<a href="${href}" target="_blank" rel="noopener">${label}</a>`;
